import flags from './flags.json' with { type: 'json' }

export type FlagKey = keyof typeof flags

export const flagKeys = Object.fromEntries(
  (Object.keys(flags) as FlagKey[]).map(k => [k, k]),
) as { [K in FlagKey]: K }
